import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import { useRef, useState, useEffect } from 'react';
import HTMLFlipBook from 'react-pageflip';
import { getStyle } from './utils.es.js';
import '@teko-builder/types/pb';
import '@teko-builder/icons';
import { g as getImageUrlFromGoogleUserContent } from './image-1466e3c0.js';
import { Alignment } from '@teko-builder/types/shared';

const PageFlip = (_a) => {
    var { children, commonStyle, id, images, align } = _a, rest = __rest(_a, ["children", "commonStyle", "id", "images", "align"]);
    const pageFlipRef = useRef();
    const [pageFlipKey, setPageFlipKey] = useState(0);
    const DEFAULT_WIDTH = 596;
    const DEFAULT_HEIGHT = 842;
    useEffect(() => {
        setPageFlipKey((key) => key + 1);
    }, [
        rest.autoSize,
        rest.drawShadow,
        rest.flippingTime,
        rest.height,
        rest.width,
        rest.maxHeight,
        rest.maxWidth,
        rest.maxShadowOpacity,
        rest.mobileScrollSupport,
        rest.showCover,
        rest.size,
        rest.startZIndex,
        rest.usePortrait,
    ]);
    return (jsx(Wrapper, Object.assign({ commonStyle: commonStyle, id: id, align: align }, { children: jsx(HTMLFlipBook, Object.assign({ ref: pageFlipRef }, rest, { width: rest.width || DEFAULT_WIDTH, height: rest.height || DEFAULT_HEIGHT }, { children: images === null || images === void 0 ? void 0 : images.map((image, index) => {
                const { src, googleImageParams } = image;
                return (jsx(Page, { src: getImageUrlFromGoogleUserContent(src, Object.assign({ format: 'webp' }, googleImageParams)) }, index));
            }) }), pageFlipKey) })));
};
const transformAlign = (align) => {
    switch (align) {
        case Alignment.center:
            return 'margin: 0 auto;';
        case Alignment.right:
            return `
        margin: 0 auto;
        margin-right: 0;
      `;
        default:
            return '';
    }
};
const Wrapper = styled.div(({ commonStyle, align }) => `
  display: flex;
  width: 100%;
  max-width: 100% !important;
  max-width: fit-content;
  position: relative;
  padding-bottom: 1rem;
  padding-top: 1rem;
  overflow: hidden;
  ${getStyle(commonStyle)}
  ${transformAlign(align)}
`);
const Page = styled.div(({ src }) => `
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${src});
`);
PageFlip.displayName = 'PageFlip';

export { PageFlip as P };
